<template>
    <footer class="flex flex-col items-center mx-auto p-[10px] py-[40px] w-full max-w-[1350px]">
        <div class="flex lg:flex-row flex-col justify-between items-center gap-[20px] mx-auto w-full">
            <div class="">
                <p>Dev by NotSasha & content by <a href="https://t.me/animeolsiortv" target="_blank" class="link">akademon83</a> with 🩵</p>
            </div>
            <div class="">
                <a href="https://t.me/animeolsiortv" target="_blank" aria-label="telegramlink">
                    <svg xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img"
                        class="iconify iconify--ic" width="32" height="32"
                        alt="Telegram"
                        preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                        <path fill="currentColor"
                            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19c-.14.75-.42 1-.68 1.03c-.58.05-1.02-.38-1.58-.75c-.88-.58-1.38-.94-2.23-1.5c-.99-.65-.35-1.01.22-1.59c.15-.15 2.71-2.48 2.76-2.69a.2.2 0 0 0-.05-.18c-.06-.05-.14-.03-.21-.02c-.09.02-1.49.95-4.22 2.79c-.4.27-.76.41-1.08.4c-.36-.01-1.04-.2-1.55-.37c-.63-.2-1.12-.31-1.08-.66c.02-.18.27-.36.74-.55c2.92-1.27 4.86-2.11 5.83-2.51c2.78-1.16 3.35-1.36 3.73-1.36c.08 0 .27.02.39.12c.1.08.13.19.14.27c-.01.06.01.24 0 .38z">
                        </path>
                    </svg>
                </a>
            </div>
        </div>
        <div class="mt-[30px] w-full text-$primary text-center">
            {{ $t('ap') }} <a class="underline" href="mailto:Olsior123@gmail.com">Olsior123@gmail.com</a>
        </div>
    </footer>
</template>
